PJQ.models.commitments.Commitment = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'commitments',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.commitments.CommitmentAttachments(model.attachments);
        this.w9Attachments = new PJQ.collections.commitments.CommitmentAttachments(model.w9Attachments);
        this.coiAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.coiAttachments);
        this.lienWaiverAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.lienWaiverAttachments);
        this.signedDocumentAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.signedDocumentAttachments);
        this.affidavitAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.affidavitAttachments);
        this.executedDocumentAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.executedDocumentAttachments);
        this.customFieldAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.customFieldAttachments);

        this.lineItems = new PJQ.collections.commitments.CommitmentLineItems(model ? model.lineItems : null);
        this.changeOrders = new PJQ.collections.commitments.ChangeOrders(model ? model.changeOrders : null);
        this.invoices = new PJQ.collections.invoicing.PayableInvoices(model ? model.invoices : null);
        this.payments = new PJQ.collections.invoicing.PayableInvoicePayments(model.payments);

        this.markupItems = new PJQ.financialMarkups.collections.FinancialMarkups(model ? model.markupItems : null);

        if (model.contractedContact) {
            if (model.contractedContact instanceof PJQ.models.BaseModel) {
                this.contractedContact = model.contractedContact;
            } else {
                this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
            }
        }

        if (model.invoiceContact) {
            if (model.invoiceContact instanceof PJQ.models.BaseModel) {
                this.invoiceContact = model.invoiceContact;
            } else {
                this.invoiceContact = new PJQ.models.contacts.Contact(model.invoiceContact);
            }
        }

        return model;
    },
    beforeSave: function () {
        let newMarkupLines = this.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.lineItems.remove(newMarkupLines);

        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            w9Attachments: this.w9Attachments.toJSON(),
            coiAttachments: this.coiAttachments.toJSON(),
            lienWaiverAttachments: this.lienWaiverAttachments.toJSON(),
            signedDocumentAttachments: this.signedDocumentAttachments.toJSON(),
            affidavitAttachments: this.affidavitAttachments.toJSON(),
            executedDocumentAttachments: this.executedDocumentAttachments.toJSON(),
            customFieldAttachments: this.customFieldAttachments.toJSON(),
            markupItems: this.markupItems.toJSON()
        });
    },
    submit: function (callback) {
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/submit',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.set(this.parse(response));
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(false);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                return 'https://app.sandbox.qbo.intuit.com/app/purchaseorder?txnId=' + externalId;
            default:
                return '';
        }
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    getSubTotal: function () {
        return this.get('amount') + this.get('markupAmount');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount');
    }
});

PJQ.models.commitments.HistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'submit': 'Submitted',
        'signed': 'Signed & Submitted',
        'email': 'Email Sent'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.commitments.commitmentStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.commitments.commitmentStatusNames[toStatus];
            case 'email':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.commitments.CommitmentLineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.commitments.CommitmentAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.commitments.CustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.commitments.CustomFieldChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'customfields',
                value: this.get('customFieldId')
            },
            {
                endpoint: 'choices',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.commitments.Settings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitments'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.commitments.Term = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'termsId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'terms',
                value: this.id
            }
        ]);
    }
});

PJQ.models.commitments.FieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'commitments'
            }
        ]);
    }
});

PJQ.models.commitments.CommitmentUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.collections.commitments.Commitments = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.Commitment,
    endpoint: function () {
        let params = [];
        if (this.options.withLineItems) {
            params.push({
                parameter: 'withLineItems',
                value: this.options.withLineItems
            });
        }
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'commitments'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        _.each(PJQ.constants.commitments.commitmentStatusBuckets, function (bucket) {
            let total = 0;
            _.each(this.models, function (commitment) {
                if (bucket.statuses.indexOf(commitment.get('statusId')) !== -1) {
                    total += commitment.get('amount');
                }
            });
            result[bucket.name] = total;
        }, this);
        return result;
    }
});

PJQ.collections.commitments.History = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.HistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments',
                value: this.options.commitmentId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.commitments.CommitmentLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.CommitmentLineItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments',
                value: this.options.commitmentId
            },
            {
                endpoint: 'lineitems'
            }
        ], params);
    }
});

PJQ.collections.commitments.CommitmentAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.CommitmentAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments',
                value: this.options.commitmentId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.commitments.CustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.CustomField,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitments'
                },
                {
                    endpoint: 'customfields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'customfields'
            }
        ]);
    }
});

PJQ.collections.commitments.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.CustomFieldChoice
});

PJQ.collections.commitments.Terms = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.Term,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitments'
                },
                {
                    endpoint: 'terms'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'terms'
            }
        ]);
    }
});

PJQ.collections.commitments.FieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.FieldSetting,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'fields',
                    value: 'commitments'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'commitments'
            }
        ]);
    }
});
